import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import "../../../Pages/Home/Sections/sections.scss";
import {ConvertToJalali, RewardsData} from "../../StoreDetail/StoreDetailServices";
import {FestivalData} from "../../Festival/FestivalServices";
import SwiperId from "react-id-swiper";
import SimpleLineIcon from "react-simple-line-icons";

const MultipleListDesktop = ({item}) =>{

    //vars
    const history = useHistory();
    const [festivals,setFestivals] = useState([])



    const imageParams = {
        slidesPerView: '4',
        spaceBetween: 20,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 8
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 8
            },
            400: {
                slidesPerView: 2,
                spaceBetween: 8
            },
            320: {
                slidesPerView: 2,
                spaceBetween: 8
            }
        }
    }





    //fetch festivals ------------------------------------------------------
    const getFestivals = async () => {
        try{
            let response = await FestivalData();
            let Campaigns = response.data.sortBy('order');
            setFestivals(Campaigns);
        }catch (e) {
            // console.log(e)
        }
    }

    useEffect(()=>{
        // getFestivals(item.mall_uid)
        setFestivals(item.items)
    },[])



    return(
        <div className="CampaignList-container" style={{margin: "20px 16px 0 16px"}}>
            {/*Festival*/}
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="storeDetail-festival">
                {/*{festivals && festivals.length>0?<div  className="storeDetail-festival-titre">*/}
                {/*    جشنواره ها*/}
                {/*</div>:null}*/}
                <div className="storyDetail-festival-slider" style={{margin:"4px"}}>
                    {festivals && festivals.length>0? <SwiperId {...imageParams}>
                        {festivals.map(reward=>{
                            return(
                                <div key={reward.uid} className="Store-slide" onClick={()=>{
                                    if(reward.link_to_uid){
                                        let res = reward.link_to_uid.replace("online-store-categories","shop")
                                        history.push(res)
                                        // history.push(`${reward.link_to_uid}`)
                                    }
                                }}>
                                    <img src={reward.image_desktop} alt=""/>
                                    <div className="festival-slide-title">
                                        <span>{reward.title}</span>
                                    </div>
                                </div>
                            )
                        })}
                    </SwiperId>:null}
                </div>

            </div>
        </div>
    )
}

export {MultipleListDesktop}
